import { QueryNames } from './queryNames.js';
import useVahakHttpClient from '../../hooks/useVahakHttpClient.js';
import { useVahakMutationQuery } from '../../hooks/useVahakQueryClient.js';
import API from '../const.js';

const useBlockUsers = () => {
    const { POST } = useVahakHttpClient();
    function blockUser(data) {
        /**
         * The first generic is for the body type you are sending
         * Second generic is the data returned
         */
        return POST(API.BLOCK_USERS, Object.assign({}, data));
    }
    /**
     * The second generic either send unknown or the error type
     */
    return useVahakMutationQuery(QueryNames.blockUser, blockUser);
};
const useUnBlockUsers = () => {
    const { POST } = useVahakHttpClient();
    function unBlockUser(data) {
        /**
         * The first generic is for the body type you are sending
         * Second generic is the data returned
         */
        return POST(API.UNBLOCK_USERS, Object.assign({}, data));
    }
    /**
     * The second generic either send unknown or the error type
     */
    return useVahakMutationQuery(QueryNames.unBlockUser, unBlockUser);
};

export { useBlockUsers, useUnBlockUsers };
//# sourceMappingURL=useBlockUserService.js.map
